module.exports = __webpack_public_path__ + "img/mobile scanner stand20.524d60aa.jpg";